import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { getFabricEmojiUrl } from 'state/selectors/env';
import { getAccountId } from 'state/selectors/user';
import RichTextEditorV2 from './rich-text-editor-v2';

const selector = createSelector(getFabricEmojiUrl, getAccountId, (fabricEmojiUrl, accountId) => ({
    fabricEmojiUrl,
    accountId,
}));

export default connect(selector, {})(RichTextEditorV2);
